export const GET_SUMMARY_REQUEST = 'GET_SUMMARY_REQUEST'
export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS'
export const GET_SUMMARY_FAILURE = 'GET_SUMMARY_FAILURE'